import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import StoppedIcon from '@material-ui/icons/Stop';
import PausedIcon from '@material-ui/icons/ExitToApp';
import PlayingIcon from '@material-ui/icons/DirectionsRun';
import MaxTimeIcon from '@material-ui/icons/Alarm';
import IddleIcon from '@material-ui/icons/AirlineSeatIndividualSuite';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    '& svg': {
      verticalAlign: 'middle',
    }
  }
}));

let timer =  0;

function StatsInfo(props) {
  const classes = useStyles();
  // const [time, setTime] = useState('00:00');
  const [status, setStatus] = useState('running');
  const { getStatus } = props.stats;

  // const secToStr = (sec) => {
  //   const date = new Date(null);
  //   date.setSeconds(sec);
  //   return date.toISOString().substr(11, 8);
  // }

  useEffect(() => {
    timer = setInterval(() => {
      // setTime(secToStr(getTime()).substr(-5));
      setStatus(getStatus());
    }, 1000);
    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line
  }, []);

  return (
  <span className={classes.wrapper}> &nbsp; | &nbsp;
    {status === 'stopped'  && <StoppedIcon />}
    {status === 'paused'   && <PausedIcon />}
    {status === 'running'  && <PlayingIcon />}
    {status === 'iddle'    && <IddleIcon />}
    {status === 'max-time' && <MaxTimeIcon />}
  </span>
  )
}

const mapStateToProps = (state) => {
  return { stats: state.stats }
}

export default connect(mapStateToProps)(StatsInfo);